import { render, staticRenderFns } from "./ResetSecurityProfileRootComponent.vue?vue&type=template&id=26880234&scoped=true"
import script from "./ResetSecurityProfileRootComponent.vue?vue&type=script&lang=js"
export * from "./ResetSecurityProfileRootComponent.vue?vue&type=script&lang=js"
import style0 from "./ResetSecurityProfileRootComponent.vue?vue&type=style&index=0&id=26880234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26880234",
  null
  
)

export default component.exports